import jwt_decode from 'jwt-decode';
import { DecodedToken } from '@/types/request';

export const decode = <T>(token: string): T & { exp: number } => {
  const decodedToken = jwt_decode<DecodedToken>(token);
  const payload = JSON.parse(decodedToken.payload);
  return { ...payload, exp: decodedToken.exp && decodedToken.exp * 1000 };
};
